(function () {
  'use strict';

  function currentNeededOptions() {
    var row = document.querySelector('.em-bundle-row.is-selected');
    var attr = row ? row.getAttribute('data-needs-options') : '';
    return attr ? attr.split(' ').filter(Boolean) : [];
  }

  function selectBundle(row) {
    var rows = document.querySelectorAll('.em-bundle-row');
    rows.forEach(function (r) { r.classList.remove('is-selected'); });
    row.classList.add('is-selected');

    var variantId = row.getAttribute('data-variant-id');
    var nowMoney = row.getAttribute('data-now-money');
    var wasMoney = row.getAttribute('data-was-money');
    var saveLabel = row.getAttribute('data-save-label') || '';
    var needed = row.getAttribute('data-needs-options') ? row.getAttribute('data-needs-options').split(' ').filter(Boolean) : [];

    document.querySelectorAll('[data-em-variant-input]').forEach(function (el) { el.value = variantId; });
    // Copy the server-rendered money string as-is (not reformatted in JS) so every
    // price on the page always matches the Liquid-rendered format. The bundle rows now
    // emit `R{{ ... | money_without_currency }}` (no space after R, matching the design)
    // rather than the store's spaced `| money` format — this JS just propagates whatever
    // string those data-*-money attributes hold, so it stays in sync automatically.
    document.querySelectorAll('[data-em-now-price]').forEach(function (el) { el.textContent = nowMoney; });
    document.querySelectorAll('[data-em-was-price]').forEach(function (el) { el.textContent = wasMoney; });
    document.querySelectorAll('[data-em-save]').forEach(function (el) { el.textContent = saveLabel; });

    // Gift rows are NOT selection-scoped: both the desktop and the mobile design show
    // "Free when you buy this bundle" on every tier that has gifts, selected or not —
    // that is what makes the 2/3/4-pack upgrade legible while a cheaper tier is active.
    // Hiding all but the selected one collapsed tiers 2 and 3 from ~250px to 125px.

    document.querySelectorAll('[data-em-option-group]').forEach(function (group) {
      var key = group.getAttribute('data-em-option-group');
      var show = needed.indexOf(key) !== -1;
      group.style.display = show ? '' : 'none';
      var select = group.querySelector('select');
      if (select) {
        select.required = show;
        if (!show) select.value = '';
      }
    });

    var errorEl = document.querySelector('[data-em-options-error]');
    if (errorEl) errorEl.style.display = 'none';
  }

  function initBundles() {
    document.querySelectorAll('.em-bundle-row').forEach(function (row) {
      row.addEventListener('click', function () { selectBundle(row); });
    });
    var preselected = document.querySelector('.em-bundle-row.is-selected') || document.querySelector('.em-bundle-row');
    if (preselected) selectBundle(preselected);
  }

  function scrollToBundles() {
    var el = document.getElementById('bundles');
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
  }

  function initScrollButtons() {
    document.querySelectorAll('[data-em-scroll-to-bundles]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        // "Buy Now" used to only scroll. Once the shopper was already at or past
        // the bundles the scroll was a no-op, so the button looked broken - which
        // is exactly what it does on a phone, where the bar is on screen the whole
        // time. Now it actually buys: submit the add-to-cart form, which already
        // validates required gift options and scrolls to any missing one.
        var form = document.querySelector('[data-em-add-to-cart-form]');
        if (form) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
          return;
        }
        scrollToBundles();
      });
    });
  }

  function validateBundleOptions() {
    var needed = currentNeededOptions();
    var missing = [];
    needed.forEach(function (key) {
      var group = document.querySelector('[data-em-option-group="' + key + '"]');
      var select = group ? group.querySelector('select') : null;
      if (select && !select.value) missing.push(select);
    });
    var errorEl = document.querySelector('[data-em-options-error]');
    if (missing.length) {
      if (errorEl) errorEl.style.display = '';
      missing[0].focus();
      if (missing[0].scrollIntoView) missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }
    if (errorEl) errorEl.style.display = 'none';
    return true;
  }

  function collectBundleProperties() {
    var row = document.querySelector('.em-bundle-row.is-selected');
    var props = {};
    if (row) {
      var includes = row.getAttribute('data-includes');
      if (includes) props['Includes'] = includes;
    }
    document.querySelectorAll('[data-em-option-input]').forEach(function (select) {
      var group = select.closest('[data-em-option-group]');
      if (group && group.style.display !== 'none' && select.value) {
        props[select.getAttribute('data-em-option-input')] = select.value;
      }
    });
    return props;
  }

  // Which free gifts each bundle tier includes, mirroring em-bundles.liquid.
  // Kept in one place so the cart can never disagree with what the tier promised.
  //
  // These are the REAL products now, not R0.00 shadow duplicates. Shopify
  // automatic Buy-X-Get-Y discounts zero them at checkout, which means the store
  // carries ONE listing per accessory instead of two, the shopper sees the actual
  // product at R0.00, and fulfilment reads a genuine TeemDrop SKU off the line
  // (e.g. SU00347674-Black toe cap lined-L/XL) rather than a free-text size note.
  // Slippers are keyed "<colour>|<size>" because the supplier stocks 5 colours x 5 EU
  // sizes and fulfilment needs the exact one; socks are keyed by size alone.
  var GIFT_VARIANTS = {
    socks: { 'S/M': 63946110861683, 'L/XL': 63946110894451, 'XXL': 63946823860595 },
    slippers: {
      'Blue|36-37': 63946852991347, 'Blue|38-39': 63946853024115, 'Blue|40-41': 63946853056883,
      'Blue|42-43': 63946853089651, 'Blue|44-45': 63946853122419,
      'Gray|36-37': 63946853155187, 'Gray|38-39': 63946853187955, 'Gray|40-41': 63946853220723,
      'Gray|42-43': 63946853253491, 'Gray|44-45': 63946853286259,
      'Pink|36-37': 63946853319027, 'Pink|38-39': 63946853351795, 'Pink|40-41': 63946853384563,
      'Pink|42-43': 63946853417331, 'Pink|44-45': 63946853450099,
      'Green|36-37': 63946853482867, 'Green|38-39': 63946853515635, 'Green|40-41': 63946853548403,
      'Green|42-43': 63946853581171, 'Green|44-45': 63946853613939,
      'Black|36-37': 63946853646707, 'Black|38-39': 63946853679475, 'Black|40-41': 63946853712243,
      'Black|42-43': 63946853745011, 'Black|44-45': 63946853777779,
    },
    mat: { 'Default': 63946113220979 },
  };

  // Resolve the shopper's choices to a real variant. Falls back to the first variant so a
  // missing/unknown option can never drop the promised gift from the order entirely.
  function giftVariantFor(key, properties) {
    var map = GIFT_VARIANTS[key] || {};
    var chosen;
    if (key === 'socks') chosen = properties['Sock size'];
    else if (key === 'slippers') chosen = properties['Slipper colour'] + '|' + properties['Slipper size'];
    return map[chosen] || map[Object.keys(map)[0]];
  }
  // How many physical massagers each bundle variant represents at the supplier.
  var SUPPLIER_UNITS = {
    63315798622579: 1, 63315839844723: 2, 63315839877491: 3, 63315839910259: 4,
  };
  var GIFTS_BY_BUNDLE = {
    63315798622579: {},                              // 1 massager - no gifts
    63315839844723: { socks: 1 },                    // 2 massagers
    63315839877491: { socks: 2 },                    // 3 massagers
    63315839910259: { socks: 3, slippers: 1, mat: 1 } // 4 massagers
  };

  function giftLinesFor(variantId, properties) {
    var spec = GIFTS_BY_BUNDLE[variantId] || {};
    var lines = [];
    Object.keys(spec).forEach(function (key) {
      var id = giftVariantFor(key, properties);
      if (!id) return;
      // Size and colour now live in the variant itself, so neither needs to travel as
      // a line-item property any more - the SKU on the line already says exactly which
      // supplier item to order.
      lines.push({ id: id, quantity: spec[key], properties: { 'Free gift': 'Included with your bundle' } });
    });
    return lines;
  }

  // Loading a selling page starts the cart from scratch.
  //
  // Without this, a shopper who tries the 2-pack, goes back and then picks the 4-pack
  // ends up with BOTH bundles and both sets of gifts stacked in one cart - and because
  // the 4-pack discount frees any five items from the gift pool, the extras ride along
  // free too. Resetting on load means what is in the cart is always the one bundle the
  // shopper last chose.
  //
  // Deliberately NOT on /cart or /checkout: clearing there would wipe the cart the
  // instant the shopper arrived to pay, and nobody could ever complete an order.
  // Also NOT when the shopper arrived from a cart-recovery email. Those emails exist to
  // send someone back to a cart they left behind, so wiping it on arrival would make the
  // recovery email destroy the exact thing it is recovering. Any email/automation click
  // through (utm_medium=email, or Omnisend's own source tag) keeps the cart intact.
  var cartReset = Promise.resolve();
  function fromRecoveryEmail() {
    var q = (window.location.search || '').toLowerCase();
    return q.indexOf('utm_medium=email') > -1 ||
      q.indexOf('utm_source=omnisend') > -1 ||
      q.indexOf('omnisend') > -1 ||
      q.indexOf('keep_cart=1') > -1;
  }
  function initCartReset() {
    var path = window.location.pathname;
    if (/\/(cart|checkout|orders)(\/|$)/.test(path)) return;
    if (fromRecoveryEmail()) return;
    cartReset = fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    }).catch(function () {});
  }

  // One add-to-cart at a time.
  //
  // Four separate CTAs ("Buy Now", "Get 60% Off Today", "Claim My 60% Off", the hero
  // button) all submit this one form, and none of them disable on click. A shopper who
  // tapped twice because the redirect to /cart had not happened yet got the massager
  // added TWICE - two units of the single-massager variant at R2459.98, when they only
  // ever wanted one. That is a real order we lost. Every path lands on this submit
  // handler, so one guard here closes all four.
  var addInFlight = false;

  function initAddToCart() {
    document.querySelectorAll('[data-em-add-to-cart-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addInFlight) return;
        var button = form.querySelector('button[type="submit"]');
        var variantInput = form.querySelector('[data-em-variant-input]');
        if (!variantInput || !variantInput.value) return;
        if (!validateBundleOptions()) return;
        addInFlight = true;
        var properties = collectBundleProperties();
        var variantId = parseInt(variantInput.value, 10);
        // The pack goes in as a REAL quantity of the real supplier SKU, not one line
        // claiming to be four. Variant prices are per massager, so 4 x R825 bills the
        // R3300 bundle price, and the order shows "4 x SU00129676-Gray" - which is what
        // any supplier sync (or human) needs to ship the right number of units. Encoding
        // the count in a SKU suffix or a text note meant a 4-pack shipped as one.
        var units = SUPPLIER_UNITS[variantId] || 1;
        var item = { id: variantId, quantity: units };
        if (Object.keys(properties).length) item.properties = properties;

        // The gifts used to travel as a text property on the massager line, so the
        // shopper reached checkout and saw only the massager - the thing they were
        // promised for free was invisible at the exact moment they were deciding to
        // pay. They now go in as real R0.00 line items, carrying the sizes chosen
        // above, so checkout lists every physical item in the box.
        var items = [item].concat(giftLinesFor(variantId, properties));

        if (button) { button.disabled = true; }
        // Wait for the page-load reset to land first. A shopper who clicks within a few
        // hundred ms of load would otherwise have their bundle added and then wiped by
        // the clear still in flight, and arrive at an empty cart.
        cartReset
          .then(function () {
            return fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: items }),
            });
          })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () {
            window.location.href = window.Shopify.routes.root + 'cart';
          })
          .catch(function (err) {
            // Release the guard so a genuine retry is possible after a failure.
            addInFlight = false;
            if (button) { button.disabled = false; }
            console.error('EMSense add to cart failed', err);
            window.location.href = window.Shopify.routes.root + 'cart';
          });
      });
    });
  }

  function initStickyBar() {
    var bar = document.querySelector('.em-sticky-bar');
    var hero = document.getElementById('em-hero-section');
    if (!bar || !hero) return;
    var onScroll = function () {
      var show = window.scrollY > hero.offsetTop + hero.offsetHeight;
      bar.classList.toggle('is-visible', show);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initFaq() {
    document.querySelectorAll('.em-faq-item').forEach(function (item) {
      var trigger = item.querySelector('.em-faq-trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        document.querySelectorAll('.em-faq-item.is-open').forEach(function (i) { i.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  function initHeroGallery() {
    var stage = document.querySelector('.em-hero-stage');
    var items = document.querySelectorAll('.em-hero-item');
    var thumbs = document.querySelectorAll('[data-em-hero-thumb]');
    if (!stage || !items.length || !thumbs.length) return;
    var setActive = function (index) {
      items.forEach(function (el, i) {
        var active = i === index;
        el.style.display = active ? 'block' : 'none';
        el.classList.toggle('is-active', active);
        if (el.tagName === 'VIDEO') {
          if (active) { var p = el.play && el.play(); if (p && p.catch) p.catch(function () {}); }
          else { el.pause && el.pause(); }
        }
      });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    };
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { setActive(i); });
    });
    document.querySelectorAll('[data-em-hero-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = Array.prototype.findIndex.call(thumbs, function (t) { return t.classList.contains('is-active'); });
        setActive((current - 1 + thumbs.length) % thumbs.length);
      });
    });
    document.querySelectorAll('[data-em-hero-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = Array.prototype.findIndex.call(thumbs, function (t) { return t.classList.contains('is-active'); });
        setActive((current + 1) % thumbs.length);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCartReset();
    initBundles();
    initScrollButtons();
    initAddToCart();
    initStickyBar();
    initFaq();
    initHeroGallery();
  });
})();
